export function getChunks(file, blockSize) {
    let chunks = [];
	console.log(file)
    let count = Math.ceil(file.size / blockSize);
    for (let i = 0; i < count; i++) {
        let chunk = file.slice(
            blockSize * i,
            i === count - 1 ? file.size : blockSize * (i + 1)
        );
        chunks.push(chunk);
    }
    return chunks;
}

export function computeMd5(data) {
    return readAsArrayBuffer(data).then(buffer => {
        let spark = new SparkMD5.ArrayBuffer();
        spark.append(buffer);
        return spark.end();
    });
}

export function readAsArrayBuffer(data) {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsArrayBuffer(data);
        reader.onload = evt => {
            let body = evt.target.result;
            resolve(body);
        };
        reader.onerror = () => {
            reject(new Error("fileReader 读取错误"));
        };
    });
}

export function getProgressInfoItem(loaded, size) {
    return {
        loaded: loaded,
        size: size,
        percent: loaded / size * 100
    };
}

// 数组排序
export function compare(property){
    return function(a,b){
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
    }
}

// 去除url上的所有参数
export function removeUrlParameters(url) {
  if (url.indexOf('?') !== -1) {
    return url.split('?')[0]
  }
  return url
}

// 去除url域名
export function removeUrlDomainName(url) {
	return url.replace(/^(http:|https:)\/\/[^/]+/, "")
}



// WEBPACK FOOTER //
// ./src/utils/huaweiUploadUiti.js